const STORAGE_KEY = 'accountSetupDeluxeEnvironment';

const normalizeEnvironment = (value) => {
  if (!value) return null;
  const normalized = String(value).trim().toUpperCase();
  if (normalized === 'SANDBOX' || normalized === 'PRODUCTION') {
    return normalized;
  }
  return null;
};

const getDefaultEnvironment = () => 'SANDBOX';

export const getDeluxeEnvironment = () => {
  try {
    const stored = normalizeEnvironment(localStorage.getItem(STORAGE_KEY));
    if (stored) return stored;
  } catch {
    // localStorage may be unavailable
  }

  return getDefaultEnvironment();
};

export const setDeluxeEnvironment = (env) => {
  const normalized = normalizeEnvironment(env);
  if (!normalized) return;
  try {
    localStorage.setItem(STORAGE_KEY, normalized);
  } catch {
    // ignore storage failures
  }
};

export const getSubscriptionDeluxeEnvironment = (subscription) => {
  const stored =
    subscription?.deluxeEnvironment
    || subscription?.metadata?.deluxeEnvironment;
  if (stored === 'SANDBOX' || stored === 'PRODUCTION') {
    return stored;
  }
  return getDeluxeEnvironment();
};

export const isDeluxeSandbox = () => getDeluxeEnvironment() === 'SANDBOX';

export default {
  getDeluxeEnvironment,
  setDeluxeEnvironment,
  getSubscriptionDeluxeEnvironment,
  isDeluxeSandbox,
};
